import { Component, ViewEncapsulation, SimpleChanges, OnInit, OnChanges } from '@angular/core';

import { Vraag, Antwoord, Referentiegegeven, DataGroep } from '@models/claims';
import { SelectieItem, VraagboomSelectieResultaat } from '@models/vragenboom';
import { BaseVraagControlDirective } from '../base/base-vraag-control';
import { TextValidator } from '../../../utils/validation/text.validator';
import { DataService } from '@components/public_api';
import { VariableHelper } from '@services/lib/mappers/indienen-vragenboom/variable-helper';

@Component({
  selector: 'app-referentie',
  templateUrl: './referentie.component.html',
  styleUrls: ['./referentie.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReferentieComponent extends BaseVraagControlDirective<VraagboomSelectieResultaat> implements OnInit, OnChanges {
  placeholder = '';
  filterAltijdTonen = '';
  referentieItems: SelectieItem[];
  huidigeSelectie: VraagboomSelectieResultaat;

  constructor(_dataService: DataService) {
    super(_dataService);
  }

  ngOnInit() {
    this.referentieItems = [];
    this.vulReferentie();
  }

  initialize(changes: SimpleChanges): void {
    this.huidigeSelectie = new VraagboomSelectieResultaat('', '', '');
    if (this.antwoordResultaat != null && this.antwoordResultaat.resultaat != null && this.antwoordResultaat.antwoorden != null) {
      this.huidigeSelectie = new VraagboomSelectieResultaat(this.antwoordResultaat.resultaat.code, this.antwoordResultaat.resultaat.titel, this.antwoordResultaat.resultaat.omschrijving);
    }
  }

  notifyAntwoord(selectie: VraagboomSelectieResultaat) {
    const antwoorden: Antwoord[] = [];
    if (this.vraag?.antwoorden?.length > 0) {
      antwoorden.push(this.vraag.antwoorden[0]);
    }
    this.setAntwoord(antwoorden, selectie);
  }

  vulReferentie() {
    if (this.vraag?.antwoorden?.length === 1 && this.vraag.antwoorden[0].variabeleWaarden?.length === 2) {
      let antwoord = this.vraag.antwoorden[0];
      this.placeholder = 'Filter op ' + antwoord.titel;
      const varKey: string = VariableHelper.extractVariable(antwoord.variabeleWaarden[0]);
      const omsKey: string = VariableHelper.extractVariable(antwoord.variabeleWaarden[1]);

      let referentieGegevens = this._dataService.getReferentieGegevens();
      if (referentieGegevens) {
        let referentieGegevensVraagRefId = referentieGegevens.filter(r => r.id = this.vraag.referentieDataId);
        let cd, oms;

        referentieGegevensVraagRefId.forEach((ref: Referentiegegeven) => {
          ref.dataGroepen.forEach((data: DataGroep) => {
            cd = data.dataRegels.find(d => d.key === varKey);
            oms = data.dataRegels.find(d => d.key === omsKey);
            if (cd && oms) {
              this.referentieItems.push(new SelectieItem({ code: cd.value, titel: oms.value }));
            }
          });
        });
      }
    }
  }

  validate(vraag: Vraag, antwoorden: Antwoord[], resultaat: VraagboomSelectieResultaat): boolean {
    return antwoorden?.length >= 1 && TextValidator.isValidSelectie(vraag, resultaat);
  }
}
